'use client'

import { useEffect } from 'react'
import ErrorPage from '@/components/error/ErrorPage'
import { captureException } from '@nais/apm'

export default function Error({ error }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        // Ikke logg til console i tillegg — NaisConsoleInstrumentation fanger console.error og ville gitt en duplikat.
        captureException(error, { context: { digest: error.digest } })
    }, [error])

    return <ErrorPage area="arbeidsgiver" />
}
